<script type="ts">
  import { search } from "./lib/Search";
  import type { resultGroup, searchAggResult } from "./types/searchTypes";
  import { init, _ } from "svelte-i18n";

  export let id: number;
  export let lang;

  let resultGroups: resultGroup[] = [];
  let queryString = "";
  let queryTimer = null;
  let displayResults = false;
  let selectedResult = null;
  export let env = typeof a3_env !== "undefined" ? a3_env : "dev";
  export let elastic_index =
    typeof a3_elastic_index !== "undefined" ? a3_elastic_index : -1;

  const clearResults = () => {
    selectedResult = null;
    queryString = "";
    displayResults = false;
  };

  const handleSearchKeyUp = (ev) => {
    console.log(ev.key);

    if (ev.key === "Escape") {
      //clearResults();
      displayResults = false;
    } else if (ev.key === "Enter") {
      handleEnterKey();
    } else if (["ArrowDown", "ArrowUp"].includes(ev.key)) {
      handleCursorKeys(ev.key);
    } else {
      queryString = ev.target.value;
    }
  };

  const handleEnterKey = () => {
    const searchResultWrap =
      document.getElementsByClassName("ajax-search-result");
    const searchResults =
      searchResultWrap[0].getElementsByClassName("search_result");

    for (let elem of searchResults) {
      if (elem.classList.contains("selected")) {
        location.href = elem
          .getElementsByClassName("a3-product-name")[0]
          .getAttribute("href");
      }
    }
  };

  const handleCursorKeys = (direction: string) => {
    const searchResultWrap =
      document.getElementsByClassName("ajax-search-result");
    const searchResults =
      searchResultWrap[0].getElementsByClassName("search_result");

    if (direction === "ArrowDown") {
      selectedResult =
        selectedResult !== null
          ? Math.min(++selectedResult, searchResults.length - 1)
          : 0;
    } else {
      selectedResult =
        selectedResult !== null
          ? Math.max(--selectedResult, 0)
          : searchResults.length - 1;
    }

    resultGroups.forEach((rg) =>
      rg.results.forEach((result) => (result.selected = false))
    );

    let index = 0;
    resultGroups.forEach((rg) =>
      rg.results.forEach((result) => {
        result.selected = index === selectedResult;
        index++;
      })
    );

    resultGroups = resultGroups;

    const listTop = searchResultWrap[0].scrollTop;
    const listBottom = listTop + searchResultWrap[0].clientHeight;
    const itemTop = searchResults[selectedResult].offsetTop;
    const itemBottom = itemTop + searchResults[selectedResult].clientHeight;

    if (itemTop < listTop || itemBottom > listBottom) {
      searchResultWrap[0].scrollTo(0, searchResults[selectedResult].offsetTop);
    }
  };

  const handleSearchResultClick = (ev) => {
    const searchResult = ev.target.closest(".search_result");
    location.href = searchResult
      .getElementsByClassName("a3-product-name")[0]
      .getAttribute("href");
  };

  const queryChanged = async (queryString: string) => {
    clearTimeout(queryTimer);

    if (!queryString) {
      PubSub.publish("TAG_FILTER_CHANGED", {
        selectedTags: [],
      });
      return;
    }

    queryTimer = setTimeout(function () {
      search(queryString, env, elastic_index).then(function (
        results: searchAggResult
      ) {
        if (queryString.length < 1) {
          //clearResults();
          displayResults = false;
          return;
        }

        resultGroups = [
          {
            title: $_("search_bar.Products"),
            results: results.products,
          },
          {
            title: $_("search_bar.Product categories"),
            results: results.product_categories,
          },
          {
            title: $_("search_bar.Product tags"),
            results: results.product_tags,
          },
          {
            title: $_("search_bar.Pages"),
            results: results.pages,
          },
          {
            title: $_("search_bar.Posts"),
            results: results.posts,
          },
        ];

        PubSub.publish("TAG_FILTER_CHANGED", {
          selectedTags: results.product_tags.map((tag) => tag.id),
        });

        displayResults = true;
      });
    }, 100);
  };

  const handleGlobalKeyPress = async (ev) => {
    if (ev.key === "Escape") {
      // clearResults();
      displayResults = false;
    }
  };

  const handleGlobalClick = (ev) => {
    // click outside the search results area
    if (ev.target.closest(".widget_product_search") === null) {
      //clearResults();
      displayResults = false;
    }
  };

  const initLang = (lang) => {
    if (!lang) {
      const htmlTag = document.getElementsByTagName("html")[0];
      lang = htmlTag?.getAttribute("lang") ?? "en-US";
    }

    init({
      fallbackLocale: "en-US",
      initialLocale: lang,
    });
  };

  initLang(lang);

  $: queryChanged(queryString);
</script>

<div class="ajax-search-result" class:displayResults>
  {#if resultGroups.length > 0}
    {#each resultGroups as resultGroup}
      {#if resultGroup.results.length > 0}
        <h4>{resultGroup.title}</h4>

        {#each resultGroup.results as result}
          <p
            class="search_result {result.selected ? 'selected' : ''}"
            on:click={handleSearchResultClick}
          >
            <a class="a3-product-image" href={result.link}>
              <img
                width="450"
                src={result.image ??
                  "/wp-content/uploads/woocommerce-placeholder.png"}
                alt={result.title}
              />
            </a>
            <span>
              <a class="a3-product-name" href={result.link}>
                <h5>{result.title}</h5>
              </a>
              {result.description}
            </span>
          </p>
        {/each}
      {/if}
    {/each}
  {/if}
</div>
<form role="search" method="get" class="woocommerce-product-search" action="/">
  <label
    class="screen-reader-text"
    for="a3-woocommerce-product-search-field-{id}"
    >{$_("search_bar.Search for:")}</label
  >
  <input
    type="text"
    id="a3-woocommerce-product-search-field-{id}"
    class="a3-search-field"
    placeholder={$_("search_bar.Search products...")}
    autocomplete="off"
    name="s"
    on:keyup={handleSearchKeyUp}
  />
  <input type="hidden" name="post_type" value="product" />
  <button type="submit" value="Search">{$_("search_bar.Search")}</button>
</form>

<svelte:window
  on:keydown|passive={handleGlobalKeyPress}
  on:click|passive={handleGlobalClick}
/>

<style>
  .search_result {
    display: flex;
    align-items: center;
  }

  .search_result:hover {
    cursor: pointer;
    background-color: bisque;
  }

  .search_result.selected {
    background-color: bisque;
  }
  .search_result > * {
    padding: 5px;
  }
  .a3-product-image {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: 20%;
  }

  .a3-product-image img {
    object-fit: cover;
    width: 100%;
    height: 75px;
  }
  .ajax-search-result {
    display: none;
    height: 500px;
    overflow-y: scroll;
  }
  .ajax-search-result.displayResults {
    display: block !important;
  }
</style>
